import styled from "styled-components";

import * as Common from "../../Styles";
import * as MUIIcon from "@mui/icons-material";

const Theme = Common.Theme;

export const ArrowDownward = styled(MUIIcon.ArrowDownward)`
  color: #5c5c5c;
`;

export const ArrowForward = styled(MUIIcon.ArrowForward)`
  color: #5c5c5c;
`;

export const EditOutlineIcon = styled(MUIIcon.EditOutlined)`
  color: #666;
	font-size: 16px !important;
	color: ${Theme.darkGrey};
`;

export const LinkIcon = styled(MUIIcon.InsertLink)`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  padding: 4px;
`;
